<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">跟进记录</span>
    </div>
    <div style="margin-bottom: 12px">
      <span
        class="mwow-button-filled primary"
        @click="exportList"
        v-debounce="1000"
        >导出</span
      >
    </div>
    <common-search-form-wrapper :reset="resetSearch">
      <el-form
        size="mini"
        :model="searchInfo"
        label-position="left"
        label-width="64px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索：" prop="key_word">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="转化类型：" prop="student_transform_type">
              <el-radio-group
                v-model="searchInfo.student_transform_type"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">未读学员</el-radio-button>
                <el-radio-button :label="2">已读学员</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问：" prop="staff_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.staff_id"
                :defaultSelected.sync="searchInfo.staff_list"
                :jobIds="[2, 3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户意向：" prop="intent">
              <el-select
                v-model="searchInfo.degree_of_interest"
                multiple
                filterable
                default-first-option
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="D" key="0" :value="0"> </el-option>
                <el-option label="C" key="1" :value="1"> </el-option>
                <el-option label="B" key="2" :value="2"> </el-option>
                <el-option label="A" key="3" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跟进阶段：" prop="stage">
              <el-select
                v-model="searchInfo.stage"
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in followStageList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跟进方式：" prop="mode">
              <el-select
                v-model="searchInfo.mode"
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in followModeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划时间：" prop="pre_follow_date">
              <common-date-range-selector
                v-model="searchInfo.pre_follow_date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跟进状态：" prop="follow_up_state">
              <el-select
                v-model="searchInfo.follow_up_state"
                multiple
                filterable
                default-first-option
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option label="未跟进" key="1" :value="1"> </el-option>
                <el-option label="已跟进" key="2" :value="2"> </el-option>
                <el-option label="已逾期" key="3" :value="3"> </el-option>
                <el-option label="已取消" key="4" :value="4"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="完成时间：" prop="follow_date">
              <common-date-range-selector
                v-model="searchInfo.follow_date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="mwow-table"
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="学员姓名" prop="name">
        <template slot-scope="scope">
          <div v-if="scope.row.student">
            <div class="mwow-gray" v-if="scope.row.student.is_del === 1">
              {{ scope.row.student.name || "-"
              }}<span class="mwow-tag del-filled large">已删除</span>
            </div>
            <div
              v-else
              class="mwow-green"
              style="cursor: pointer"
              @click="toStudentDetail(scope.row)"
            >
              {{ scope.row.student.name || "-" }}
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="转化类型" prop="student_transform_type">
        <template slot="header">
          <span>
            <span>转化类型</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="200"
            >
              <p>
                跟进时的学员身份，未报读过的学员为未读学员，已报读过的学员为已读学员
              </p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </span>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.student_transform_type === 1">未读学员</div>
          <div v-else-if="scope.row.student_transform_type === 2">已读学员</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="跟进状态" prop="create_time">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" class="mwow-purple">未跟进</span>
          <span v-else-if="scope.row.status === 2" class="mwow-green"
            >已跟进</span
          >
          <span v-else-if="scope.row.status === 3" class="mwow-red"
            >已逾期</span
          >
          <span v-else-if="scope.row.status === 4" class="mwow-gray"
            >已取消</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="课程顾问" prop="follow_staff">
        <template slot-scope="scope">
          <span v-if="scope.row.follow_staff">{{
            scope.row.follow_staff.name || "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="用户意向" prop="intent">
        <template slot-scope="scope">
          {{ followLatentObj[scope.row.intent] || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="跟进阶段" prop="stage">
        <template slot-scope="scope">{{
          scope.row.follow_stage ? scope.row.follow_stage.name : "-"
        }}</template>
      </el-table-column>
      <el-table-column label="计划时间" prop="pre_follow_time" width="130">
        <template slot-scope="scope"
          ><span :class="scope.row.status === 3 ? 'mwow-red' : ''">{{
            scope.row.pre_follow_time
          }}</span></template
        >
      </el-table-column>
      <el-table-column
        label="完成时间"
        prop="follow_time"
        width="130"
      ></el-table-column>
      <el-table-column label="跟进方式" prop="mode">
        <template slot-scope="scope">{{
          followModeObj[scope.row.mode] || "-"
        }}</template>
      </el-table-column>
      <el-table-column label="跟进内容" prop="content">
        <template slot-scope="scope">{{ scope.row.content || "-" }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <div class="table-btns">
            <div class="btn" v-if="scope.row.status === 1">
              <log-follow-dialog
                :logData="scope.row"
                :modeList="followModeList"
                :lantentList="followLatentList"
                :stageList="followStageListPlan"
                @change="handleRefresh"
              >
                <el-button class="mwow-button inter">跟进</el-button>
              </log-follow-dialog>
            </div>
            <div
              class="btn"
              v-if="scope.row.status === 1 || scope.row.status === 3"
            >
              <log-edit-dialog :logData="scope.row" @change="handleRefresh">
                <el-button class="mwow-button success">编辑</el-button>
              </log-edit-dialog>
            </div>
            <div
              class="btn"
              v-if="scope.row.status === 1 || scope.row.status === 3"
            >
              <log-cancel-dialog :logId="scope.row.id" @change="handleRefresh">
                <el-button class="mwow-button danger">取消</el-button>
              </log-cancel-dialog>
            </div>
            <div
              class="btn"
              v-if="scope.row.status === 2 && scope.row.student.is_del === 2"
            >
              <log-detail-dialog
                :logData="scope.row"
                :modeList="followModeList"
                :lantentList="followLatentList"
                :stageList="followStageList"
              >
                <el-button class="mwow-button primary">查看</el-button>
              </log-detail-dialog>
            </div>
            <div class="btn">
              <el-button
                class="mwow-button info"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import { dateFormat } from "@/utils/timeFormat";
import {
  getFollowAllListApi,
  getFollowModeApi,
  getFollowStageApi,
  deletefollowLogApi,
  getFollowLatentApi,
  studentFollowExportApi,
} from "@/api/studentFollow";
import logDetailDialog from "./logDetailDialog.vue";
import logEditDialog from "./logEditDialog.vue";
import logFollowDialog from "./logFollowDialog.vue";
import logCancelDialog from "./logCancelDialog.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "followStudentLog",
  components: {
    logDetailDialog,
    logEditDialog,
    logFollowDialog,
    logCancelDialog,
    commonStaffPullDown,
    CommonSearchFormWrapper,
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        degree_of_interest: [],
        pre_follow_date: [],
        status: -1,
        follow_date: [],
        // status: -1,
        follow_up_state: [],
        staff_id: "",
        staff_list: [],
        student_transform_type: -1,
      },
      followStageList: [],
      followStageListPlan: [],
      followStageObj: {},
      followModeList: [],
      followModeObj: {},
      followLatentList: [],
      followLatentObj: {},
      tableData: [],
      multipleSelection: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    const route = this.$route.query;
    if (route.from === "salesData") {
      this.searchInfo.stage = Number(route.key);
      this.searchInfo.follow_date[0] = route.s_time;
      this.searchInfo.follow_date[1] = route.e_time;
    }
    getFollowStageApi({ include_del: 1 }).then((res) => {
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followStageList = res.data.list;
    });
    getFollowStageApi({ include_del: 0 }).then((res) => {
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followStageListPlan = res.data.list;
      this.followStageObj = obj;
      getFollowModeApi().then((res) => {
        const obj = {};
        res.data.list.map((item) => {
          obj[item.key] = item.value;
        });
        this.followModeList = res.data.list;
        this.followModeObj = obj;
      });
      getFollowLatentApi().then((res) => {
        const obj = {};
        res.data.list.map((item) => {
          obj[item.key] = item.value;
        });
        this.followLatentList = res.data.list;
        this.followLatentObj = obj;
      });
    });
    if (PageModule.latestRoute === "studyDetails") {
      const cache = PageModule.pageInfo.recruitFollowList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      const params = this.$route.params;
      if (params.staff_id) {
        this.searchInfo.staff_id = Number(params.staff_id);
      }
      if (params.follow_start_time && params.follow_end_time) {
        this.searchInfo.pre_follow_date = [
          params.follow_start_time,
          params.follow_end_time,
        ];
      }
      if (params.status) {
        this.searchInfo.follow_up_state = JSON.parse(params.status);
      }
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  },
  methods: {
    resetSearch() {
      this.searchInfo = {
        degree_of_interest: [],
        pre_follow_date: [],
        status: -1,
        follow_up_state: [],
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh(type) {
      let page = this.page;
      if (
        type === "delete" &&
        (this.page - 1) * this.pageSize + 1 === this.total
      ) {
        page = page - 1;
      }
      this.getList({
        page: page > 0 ? page : 1,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.staff_id !== "") {
        option.staff_id = this.searchInfo.staff_id;
      }
      if (this.searchInfo.stage !== "") {
        option.stage = this.searchInfo.stage;
      }
      if (this.searchInfo.mode !== "") {
        option.mode = this.searchInfo.mode;
      }
      if (
        this.searchInfo.pre_follow_date &&
        this.searchInfo.pre_follow_date.length === 2
      ) {
        option.pre_follow_start_time =
          new Date(
            this.searchInfo.pre_follow_date[0].replace(/-/g, "/")
          ).getTime() / 1000;
        option.pre_follow_end_time =
          new Date(
            this.searchInfo.pre_follow_date[1].replace(/-/g, "/")
          ).getTime() /
            1000 +
          (24 * 60 * 60 - 1);
      }
      if (
        this.searchInfo.follow_date &&
        this.searchInfo.follow_date.length === 2
      ) {
        option.follow_start_time = this.searchInfo.follow_date[0];
        option.follow_end_time = this.searchInfo.follow_date[1];
      }
      if (this.searchInfo.follow_up_state.length > 0) {
        option.status_arr = this.searchInfo.follow_up_state;
      }
      if (this.searchInfo.degree_of_interest.length > 0) {
        option.intent_arr = this.searchInfo.degree_of_interest;
      }
      if (this.searchInfo.student_transform_type > 0) {
        option.student_transform_type = this.searchInfo.student_transform_type;
      }
      getFollowAllListApi(option).then((res) => {
        this.page = res.data.page;
        this.total = res.data.total;
        res.data.list.map((item) => {
          item.content =
            item.content.length > 20
              ? item.content.slice(0, 20) + "..."
              : item.content;
          item.pre_follow_time =
            item.pre_follow_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.pre_follow_time * 1000);
          item.follow_time =
            item.follow_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.follow_time * 1000);
        });
        this.tableData = res.data.list;
      });
    },
    toStudentDetail(row) {
      PageModule.SET_PAGE_INFO({
        name: "recruitFollowList",
        key: "search_info",
        value: { ...this.searchInfo },
      });
      this.$router.push({
        name: "studyDetails",
        query: { id: row.student.student_id, tab: "followup" },
      });
    },
    handleDelete(row) {
      this.$confirm("确定删除后，跟进记录将无法恢复。", `删除 - 跟进记录`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      })
        .then(() => {
          deletefollowLogApi({ follow_id: row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleRefresh("delete");
          });
        })
        .catch(() => {});
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "recruitFollowList",
        key: "page",
        value: e,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    // 导出
    exportList() {
      const data = {};
      if (this.searchInfo.key_word) {
        data.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.staff_id !== "") {
        data.staff_id = this.searchInfo.staff_id;
      }
      if (this.searchInfo.stage !== "") {
        data.stage = this.searchInfo.stage;
      }
      if (this.searchInfo.mode !== "") {
        data.mode = this.searchInfo.mode;
      }
      if (
        this.searchInfo.pre_follow_date &&
        this.searchInfo.pre_follow_date.length === 2
      ) {
        data.pre_follow_start_time =
          new Date(
            this.searchInfo.pre_follow_date[0].replace(/-/g, "/")
          ).getTime() / 1000;
        data.pre_follow_end_time =
          new Date(
            this.searchInfo.pre_follow_date[1].replace(/-/g, "/")
          ).getTime() /
            1000 +
          (24 * 60 * 60 - 1);
      }
      if (
        this.searchInfo.follow_date &&
        this.searchInfo.follow_date.length === 2
      ) {
        data.follow_start_time = this.searchInfo.follow_date[0];
        data.follow_end_time = this.searchInfo.follow_date[1];
      }
      if (this.searchInfo.follow_up_state.length > 0) {
        data.status_arr = this.searchInfo.follow_up_state;
      }
      if (this.searchInfo.degree_of_interest.length > 0) {
        data.intent_arr = this.searchInfo.degree_of_interest;
      }
      if (this.searchInfo.student_transform_type > 0) {
        data.student_transform_type = this.searchInfo.student_transform_type;
      }
      studentFollowExportApi(data).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.table-btns {
  text-align: left;
  .btn {
    display: inline-block;
    .el-button {
      margin: 0 4px;
    }
  }
}
/deep/ .el-form {
  .el-form-item {
    margin-right: 58px;
    width: 90% !important;
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
.resetting {
  position: absolute !important;
  top: 150px !important;
  right: 0 !important;
}
</style>
